export const ModalConfig = {
  class: 'modal-dialog modal-dialog-centered',
  class_xlg: 'modal-dialog modal-dialog-centered modal-lg',
  class_md: 'modal-dialog modal-dialog-centered modal-md'

}
